import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { NotificationService } from '../../_services/notification.service';
import { environment } from '../../../environments/environment';
import { ElasticSearchService } from '../../_services/elastic-search.service';
import { UserService } from '../../_services/user.service';
import { CommentItemComponent } from '../comment-item/comment-item.component';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-comment-loader',
  templateUrl: './comment-loader.component.html',
  styleUrls: ['./comment-loader.component.css'],
  inputs: ['post', 'user']
})
export class CommentLoaderComponent implements OnInit, OnDestroy {
  post;
  user;
  isSilencedForMe: boolean;
  ipAddress: any;
  size: number;
  @ViewChild("commentText") commentText: ElementRef;
  @ViewChild(CommentItemComponent) commentItem: CommentItemComponent;
  subs = new Subscription();
  commentScroll = 3;
  userId;
  constructor(
    private elasticSearchService: ElasticSearchService,
    private userService: UserService,
    private afs: AngularFirestore,
    private _http: Http,
    private route: ActivatedRoute,
    public notificationService: NotificationService) {
    this.userId = this.userService.getUid();
  }

  ngOnInit() {
    this.getIpAdress();
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  commentKeyPress(event: KeyboardEvent) {

    if (event.keyCode === 13) {
      event.preventDefault();
      if (this.commentText.nativeElement.value.replace(/\s/g, '')) {
        this.postComment();

      }
    }
  }

  postComment() {

    let commentText = this.commentText.nativeElement.value;
    const hashtags = commentText.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) || [];
    const products = commentText.match(/@[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) || [];
    const postInPath = {};
    let post: any = {};

    Object.assign(post, this.post);
    post.id = this.post.id;
    let html = commentText;
    hashtags.forEach(hashtag => {
      hashtag = hashtag.substring(1);
      html = html.replace("#" + hashtag, '<a href="hashtag/' + hashtag.toLowerCase() + '">#' + hashtag + '</a>');
    });

    let userInfo: any = {};
    if (post.settings.isNameSecret && post.author.username == this.user.username) {
      userInfo.firstname = "İçimizden";
      userInfo.lastname = "Biri";
    } else {
      userInfo.firstname = this.user.firstname;
      userInfo.lastname = this.user.lastname;
    }
    const comment = {
      text: commentText,
      html: html,
      user: {
        firstname: userInfo.firstname,
        lastname: userInfo.lastname,
        profileImage: this.user.profileImage,
        username: this.user.username
      },
      modifyDate: Date.now()
    };
    if (products.length) {
      this.elasticSearchService.getProducts(products, hits => {
        hits.filter((data: any) => {
          if (data.type == "user") {
            let userInfo: any = {};
            if (post.settings.isNameSecret && post.author.username == this.user.username) {
              userInfo.firstname = "İçimizden";
              userInfo.lastname = "Biri";
              userInfo.profileImage = "no-image.png";
            } else {
              userInfo.firstname = this.user.firstname;
              userInfo.lastname = this.user.lastname;
              userInfo.profileImage = this.user.profileImage;
            }
            let message = {
              body: '<span><strong>' + userInfo.firstname + ' ' + userInfo.lastname + '</strong> seni bir yorumda etiketledi.</span>',
              innerBody: userInfo.firstname + ' ' + userInfo.lastname + ' seni bir yorumda etiketledi.',
              click_action: environment.domainName + "post/" + this.post.$key,
              action: "post/" + this.post.$key,
              image: userInfo.profileImage,
              postText: post.innerText,
              postUser: post.settings.isNameSecret ? "İçimizden Biri" : post.author.firstname + " " + post.author.lastname,
              isUnseen: true,
              modifyDate: Date.now(),
              title: "Etiket"
            }

          }
          if (data.type == "user" || "brand" || "product") {
            html = html.replace("@" + data.uniqueName, '<a href="' + data.uniqueName + '">@' + data.uniqueName + '</a>');
          } else {
            html = html.replace("@" + data.uniqueName, '<a href="' + data.type + '/' + data.uniqueName + '">@' + data.uniqueName + '</a>');
          }
          comment.html = html;
          if (post.comments) {
            let commentData = [];

            this.afs.collection('posts').doc(post.id).ref.get().then((comment1) => {
              comment1.data().comments.forEach(fff => {
                commentData.push(fff);
              })
              commentData.push(comment);
            }).then(() => {
              this.afs.collection('posts').doc(post.id).update({
                comments: commentData,
                valueOf: post.valueOf + 1,
                valueOf_ModifyDate: -1 * parseInt("" + (post.valueOf + 1) + post.modifyDate)
              })
            })
          }
          else {
            this.afs.collection('posts').doc(post.id).update({
              comments: [comment],
              valueOf: post.valueOf + 1,
              valueOf_ModifyDate: -1 * parseInt("" + (post.valueOf + 1) + post.modifyDate)
            })
          }
        });
      })


    } else {
      if (post.comments) {
        let commentData = [];

        this.afs.collection('posts').doc(post.id).ref.get().then((comment1) => {
          comment1.data().comments.forEach(fff => {
            commentData.push(fff);
          })
          commentData.push(comment);
        }).then(() => {
          this.afs.collection('posts').doc(post.id).update({
            comments: commentData,
            valueOf: post.valueOf + 1,
            valueOf_ModifyDate: -1 * parseInt("" + (post.valueOf + 1) + post.modifyDate)
          })
        })
      }
      else {
        this.afs.collection('posts').doc(post.id).update({
          comments: [comment],
          valueOf: post.valueOf + 1,
          valueOf_ModifyDate: -1 * parseInt("" + (post.valueOf + 1) + post.modifyDate)
        })
      }
    }

    if (post.author.username !== this.user.username) {
      this.afs.collection('users').ref.where('username', '==', post.author.username).get().then((snap => {
        if (!snap.empty) {


          const message = {
            body: '<span><strong>' + this.user.firstname + ' ' + this.user.lastname + '</strong> gönderine yorum yaptı:"' + commentText + '"</span>',
            innerBody: this.user.firstname + ' ' + this.user.lastname + ' gönderine yorum yaptı:"' + commentText + '"',
            title: 'Yorum',
            click_action: environment.domainName + "post/" + post.id,
            action: "post/" + post.id,
            postText: post.innerText,
            postUser: post.author.firstname + " " + post.author.lastname,
            image: this.user.profileImage,
            isUnseen: true,
            modifyDate: Date.now()
          };
          this.notificationService.pushNotification(message, snap.docs[0].id);
          return false;
        }
      }));
    }
    if (post.author.username !== this.user.username) {
      this.getPoint(this.user);
    }
    this.commentText.nativeElement.value = "";
    // this.userService.userLog('post-comment', this.ipAddress)
  }
  getIpAdress() {
    this.subs.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }



  async getPoint(postUser) {

    this.afs.collection('users').ref.where('username', '==', postUser.username).get().then((userData) => {
      this.afs.collection('users').doc(userData.docs[0].id).update({
        point: {
          totalPoint: (userData.docs[0].data().point.totalPoint || 0) + 2
        }
      })
    })
  }
  focus() {
    this.commentText.nativeElement.classList.add("active");
  }
  isSilencedUser(username) {
    try {

      let array = [];
      this.afs.collection('users').doc(this.user.id).collection('silencedUser').ref.get().then((data) => {
        if (!data.empty) {
          data.forEach(silencedUser => {
            array.push(silencedUser.data());

          })
        }
      })
      this.isSilencedForMe = !array.every((data: any) => username !== data.username);
    } catch (e) {
      this.isSilencedForMe = false;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/comment-loader/comment-loader.component.ts